<template>
  <div class="d-none d-md-block" style="margin-bottom: 75px; z-index: 500">
    <v-app-bar fixed :height="75" class="py-1">
      <div class style="width: 30%">
        <v-toolbar-title class="logofont">
          <router-link to="/" class="nolink">
            <img src="/vp_nopad.png" style="width: 180px; height: auto" />
          </router-link>
        </v-toolbar-title>
      </div>

      <v-toolbar-items style="width: 60%; justify-content: center">
        <v-btn
          text
          @click="goTo('about')"
          small
          style="width: 100px"
          v-if="!$store.getters['isLoggedIn']"
        >
          <div class="text-center">
            <v-icon class="mb-1">fa-wrench</v-icon>
            <br />
            <span class="font-weight-bold">Features</span>
          </div>
        </v-btn>

        <v-btn
          text
          @click="goTo('pricing')"
          small
          style="width: 100px"
          v-if="!$store.getters['isLoggedIn']"
        >
          <div class="text-center">
            <v-icon class="mb-1">fa-dollar-sign</v-icon>
            <br />
            <span class="font-weight-bold">Pricing</span>
          </div>
        </v-btn>

        <v-btn text to="/about" small style="width: 100px">
          <div class="text-center">
            <img style="height: 25px; width: 28px" class src="/logo.png" />
            <br />
            <span class="font-weight-bold">About Us</span>
          </div>
        </v-btn>

        <v-btn
          text
          small
          to="/portals"
          style="width: 100px"
          v-if="$store.getters['isLoggedIn']"
        >
          <div class="text-center">
            <v-icon class="mb-1">fa-desktop</v-icon>
            <br />
            <span class="font-weight-bold">My Portals</span>
          </div>
        </v-btn>

        <v-btn
          text
          small
          v-if="$store.getters['isLoggedIn']"
          @click="$eventBus.$emit('new-portal')"
          style="width: 100px"
        >
          <div class="text-center">
            <v-icon class="mb-1" color="blue">fa-plus-circle</v-icon>
            <br />
            <span class="font-weight-bold">New Portal</span>
          </div>
        </v-btn>
      </v-toolbar-items>

      <v-toolbar-items style="width: 30%; justify-content: flex-end">
        <v-btn
          text
          small
          @click="openNewsletter"
          v-if="!$store.getters['isLoggedIn']"
          style="width: 120px"
        >
          <div class="text-center">
            <v-badge
              :value="newsLetterBell ? true : false"
              :content="newsLetterBell ? 1 : null"
            >
              <v-icon class="mb-1">fa-bell</v-icon>
            </v-badge>
            <br />
            <span class="font-weight-bold">Notifications</span>
          </div>
        </v-btn>

        <v-menu
          v-model="notifications_menu"
          offset-y
          v-if="$store.getters['isLoggedIn']"
          :min-width="400"
        >
          <template v-slot:activator="{ on }">
            <v-btn text small v-on="on" style="width: 120px">
              <div class="text-center">
                <v-badge
                  :content="$store.getters['notifications_count']"
                  :value="$store.getters['notifications_count']"
                >
                  <v-icon class="mb-1">fa-bell</v-icon>
                </v-badge>
                <br />
                <span class="font-weight-bold">Notifications</span>
              </div>
            </v-btn>
          </template>
          <v-card v-if="$store.state.notifications.length">
            <v-card-title class="secondary white--text">
              <h5>Notifications</h5>
            </v-card-title>
            <v-divider></v-divider>
            <v-list
              two-line
              class="pa-0"
              style="max-height: 325px; overflow-y: scroll"
            >
              <v-list-item-group v-model="selected">
                <template
                  v-for="(item, index) in $store.getters[
                    'notifications_sorted'
                  ]"
                >
                  <v-list-item
                    :key="index"
                    :to="item.action_url ? item.action_url : null"
                    :class="item.seen ? '' : 'new_notification'"
                  >
                    <template v-slot:default="{}">
                      <v-list-item-content>
                        <v-list-item-title
                          v-text="item.headline"
                        ></v-list-item-title>
                        <v-list-item-subtitle
                          v-text="item.message"
                        ></v-list-item-subtitle>
                      </v-list-item-content>
                      <v-list-item-action>
                        <v-list-item-action-text>{{
                          item.date_added | fromNow
                        }}</v-list-item-action-text>
                        <v-icon v-if="item.seen == 0" color="primary"
                          >fas fa-blank</v-icon
                        >
                        <v-icon v-else>fa-blank</v-icon>
                      </v-list-item-action>
                    </template>
                  </v-list-item>
                  <v-divider
                    style
                    v-if="index + 1 < $store.state.notifications.length"
                    :key="'d' + index"
                  ></v-divider>
                </template>
              </v-list-item-group>
            </v-list>
            <v-card-actions class="grey lighten-3">
              <v-spacer></v-spacer>
              <v-btn
                color="error"
                text
                v-if="$store.state.notifications.length"
                @click="$store.dispatch('clear_notifications')"
                >Clear</v-btn
              >
            </v-card-actions>
          </v-card>
          <v-card v-else>
            <v-card-text>You have no new notifications</v-card-text>
          </v-card>
        </v-menu>

        <v-btn text small to="/login" v-if="!$store.getters['isLoggedIn']">
          <div class="text-center">
            <v-icon class="mb-1">fa-user</v-icon>
            <br />
            <span class="font-weight-bold">Sign In</span>
          </div>
        </v-btn>

        <v-menu offset-y v-if="$store.getters['isLoggedIn']" :min-width="240">
          <template v-slot:activator="{ on }">
            <v-btn v-on="on" text small>
              <div class="text-center">
                <v-icon class="mb-1">fa-user</v-icon>
                <br />
                <span class="font-weight-bold">Account</span>
              </div>
            </v-btn>
          </template>
          <v-list class="py-0">
            <v-list-item to="/admin/users" v-if="$store.getters['isAdmin']">
              <v-list-item-icon>
                <v-icon>fa-cog</v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title
                  class="font-weight-bold"
                  v-text="'Admin'"
                ></v-list-item-title>
              </v-list-item-content>
            </v-list-item>

            <v-list-item
              to="/subscription"
              v-if="$store.getters['isTrial'] || !$store.state.user.subscribed"
            >
              <v-list-item-icon>
                <v-icon>fa-user-plus</v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title
                  class="font-weight-bold"
                  v-text="'Subscribe'"
                ></v-list-item-title>
              </v-list-item-content>
            </v-list-item>

            <v-list-item to="/portals">
              <v-list-item-icon>
                <v-icon>fa-desktop</v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title
                  class="font-weight-bold"
                  v-text="'My Portals'"
                ></v-list-item-title>
              </v-list-item-content>
            </v-list-item>

            <v-list-item
              @click="$store.dispatch('loadBilling')"
              v-if="!$store.getters['isTrial'] && $store.state.user.subscribed"
            >
              <v-list-item-icon>
                <v-icon>fa-wallet</v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title
                  class="font-weight-bold"
                  v-text="'Billing'"
                ></v-list-item-title>
              </v-list-item-content>
            </v-list-item>

            <v-divider></v-divider>
            <v-list-item @click="logout" class>
              <v-list-item-icon>
                <v-icon>fa-walking</v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title
                  class="font-weight-bold"
                  v-text="'Sign Out'"
                ></v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list>
        </v-menu>
      </v-toolbar-items>
    </v-app-bar>
  </div>
</template>
<script>
export default {
  name: "",
  data: () => ({
    newsletter_prompted: false,
    selected: "",
    notifications_menu: false,
  }),
  watch: {
    selected: function () {
      this.$store.dispatch("seen_notifications");
    },
    notifications_menu: function (to) {
      if (to === false) {
        this.$store.dispatch("seen_notifications");
      }
    },
  },
  computed: {
    newsLetterBell() {
      if (this.newsletter_prompted) {
        return null;
      }
      if (localStorage.getItem("newsletter_prompted")) {
        return null;
      }
      return 1;
    },
  },
  methods: {
    goTo(hash) {
      if (this.$route.name === "Home") {
        this.$vuetify.goTo(`#${hash}`, { offset: 75 });
      } else {
        this.$router.push(`/#${hash}`);
      }
    },
    logout() {
      this.$store.commit("logout");
      this.$router.push("/");
    },
    openNewsletter: function () {
      localStorage.setItem("newsletter_prompted", new Date().getTime());
      this.newsletter_prompted = true;
      this.$eventBus.$emit("show_newsletter");
    },
  },
};
</script>
<style lang="scss" scoped>
.theme--light.v-btn--active::before {
  opacity: 0;
}

.logofont {
  font-family: "Arial Rounded MT Bold", sans-serif;
  font-size: 32px;
  letter-spacing: -1.5px;
}
.new_notification {
  border-left: 5px solid #ff5744;
}
</style>
